import React from "react"
import { Canvas } from "@react-three/fiber"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
import { useLoader } from "@react-three/fiber"
import styled, { css } from "styled-components"
import CompIcon from "../icons/Comp"
import DriveIcon from "../icons/Drive"
import FeedIcon from "../icons/Feed"
import MtIcon from "../icons/Mt"
import HeadIcon from "../icons/Head"
const Model = ({ path }) => {
  const gltf = useLoader(GLTFLoader, path)
  return <primitive pathect={gltf.scene} />
}

const CategoryIconWrapper = styled.div`
  flex: auto;
  text-align: center;
  display: flex;
  align-items: center; /* 垂直方向の中央揃え */
  justify-content: center; /* 水平方向の中央揃え */
  position: relative;
  & > p {
    position: absolute;
    font-size: 0.75rem;
    margin: 0;
    color: black;
    text-shadow: 1px 1px 1px white;
    text-shadow: -1px 1px 1px white;
    text-shadow: 1px -1px 1px white;
    text-shadow: -1px -1px 1px white;
  }
`
const CategoryIcon = ({ model, onClick, category }) => {
  console.log("CategoryIcon")
  const changeAlpha = (rgbaString, newAlpha) => {
    const parts = rgbaString.match(/^rgba\((\d+),\s*(\d+),\s*(\d+)\)$/)
    if (!parts) {
      throw new Error("Invalid RGBA string")
    }
    return `rgba(${parts[1]}, ${parts[2]}, ${parts[3]}, ${newAlpha})`
  }
  let Icon
  let fillColor
  let strokeColor
  fillColor = changeAlpha(model.color, 0.7)
  strokeColor = model.color
  switch (category) {
    case "drive":
      Icon = DriveIcon
      break
    case "comp":
      Icon = CompIcon
      break
    case "feed":
      Icon = FeedIcon
      break
    case "mt":
      Icon = MtIcon
      break
    case "head":
      Icon = HeadIcon
      break
    default:
      break
  }
  return (
    <CategoryIconWrapper
      onClick={onClick}
      color={changeAlpha(model.color, 0.1)}
      style={{ cursor: "pointer" }}
    >
      <Icon fill={fillColor} strokeColor={strokeColor} strokeWidth={0.5} />
      <p>{model.name}</p>
    </CategoryIconWrapper>
  )
}

export default CategoryIcon
